import type { PipelineState, FacilityPeakValues } from '@/modules/axios/types/types'

export const HOG_FACTOR = 0.85

/** Production days = span from first to last day with biomass or fish (inclusive), within the given row range. */
export function computeProductionDays(state: PipelineState, fromRow = 0, toRow = state.matrices.facilityMatrices.biomass.rows): number {
  const { facilityMatrices } = state.matrices
  const biomass = facilityMatrices.biomass
  let firstDay = -1
  let lastDay = -1
  for (let row = fromRow; row < toRow; row++) {
    if (biomass.get(row, 0) > 0 || facilityMatrices.fishNumber.get(row, 0) > 0) {
      if (firstDay === -1) firstDay = row
      lastDay = row
    }
  }
  return firstDay === -1 ? 0 : lastDay - firstDay + 1
}

export function computeFacilityAnnualValues(state: PipelineState, facilityPeakValues: FacilityPeakValues) {
  const { facilityMatrices } = state.matrices
  const { tankParameterMap } = state.input
  const delivered = facilityMatrices.deliveredBiomass

  const productionDays = computeProductionDays(state)
  if (productionDays === 0) {
    Object.assign(facilityPeakValues, { lfePerYear: 0, hogPerYear: 0, lfePerVolume: 0, hogPerVolume: 0 })
    return
  }

  // Sum all delivered biomass across the full simulation
  let totalDelivered = 0
  for (let row = 0; row < delivered.rows; row++) {
    totalDelivered += delivered.get(row, 0)
  }

  const lfePerYear = (totalDelivered / productionDays) * 365
  const hogPerYear = lfePerYear * HOG_FACTOR

  let volume = 0
  for (const [, params] of tankParameterMap) {
    volume += params.tank_volume
  }

  Object.assign(facilityPeakValues, {
    lfePerYear,
    hogPerYear,
    lfePerVolume: volume > 0 ? lfePerYear / volume : 0,
    hogPerVolume: volume > 0 ? hogPerYear / volume : 0
  })
}
